import React from 'react'
import Layout from '../../layout/Layout/Layout'
import '../../styles/dashboard.css'
import { useTranslation } from 'react-i18next'
import { MENU_KEYS, MENU_SIDEBAR_KEYS, ART_WORK_KEYS } from '../../utils/translation-constants'
import { NavLink } from 'react-router-dom'
import UserDetail from '../new-design/dashboard-header/userDetail'
import AdBanner from '../new-design/dashboard-header/adBanner'
import { MENU_OPTIONS } from '../../layout/Layout/menu-options'
import Side_DashboardIcon from 'custom/assets/side-bar/Dashboard_Sidebar.svg'
import NavCard from '../../layout/Navigation/nav-card'
import { getMenuListSelector } from '../../selectors'
import { useSelector } from 'react-redux'
import PortfolioIcon from 'custom/assets/dashboard/portfolio.svg'
import LoanIcon from 'custom/assets/dashboard/loan.svg'
import DepositIcon from 'custom/assets/dashboard/deposit.svg'
import ExchangeRatesIcon from 'custom/assets/quick-links/exchange.svg'
import Account_RequestIcon from 'custom/assets/accounts/Request.svg'
import TransfersIcon from 'custom/assets/dashboard/transfers.svg'
import AccountsIcon from 'custom/assets/dashboard/accounts.svg'
import PaymentsIcon from 'custom/assets/dashboard/payments.svg'
import Other_SupportCenterIcon from 'custom/assets/dashboard/otherServices.svg'
import GimacIcon from 'custom/assets/gimacpay/gimac.svg'

export default function Dashboard() {
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['DASHBOARD'] || {}

  return (
    <Layout>
      <div className='dashboard-header-section'>
        <div className='row'>
          <div className='col-5'>
            <UserDetail />
          </div>
          <div className='col-7'>
            <AdBanner />
          </div>
        </div>
      </div>
      <div className='d-flex'>
        <div>
          {/* <NavLink
            activeClassName='nav-card-selected'
            key={0}
            to={'/dashboard'}
            className='nav-card '>
            <img src={Side_DashboardIcon} />
            <h2>{t(MENU_KEYS.DASHBOARD)}</h2>
          </NavLink> */}
          <NavCard
            icon={Side_DashboardIcon}
            name={t(MENU_KEYS.DASHBOARD)}
            link={'/dashboard'}
            key={0}
          />
          {Object.keys(menuConfig).length > 0 &&
            MENU_OPTIONS.map((option, index) => (
              <>
                {
                  <NavCard
                    icon={option.s_icon}
                    name={option.title}
                    link={option.link}
                    key={index}
                  />
                  // menuConfig[option.key] &&
                  // <NavCard
                  //   icon={option.s_icon}
                  //  name={option.title}
                  //   link={option.link}
                  //  key={index}
                  ///>
                  // <NavLink
                  //   activeClassName='nav-card-selected'
                  //   key={index}
                  //   to={option.link}
                  //   className='nav-card '>
                  //   <img src={option.s_icon} />
                  //   <h2>{option.title}</h2>
                  // </NavLink>
                }
              </>
            ))}
        </div>

        <div className='d-flex dashboard-section'>
          <div>
            <NavLink to='/accounts' className='menu-card-tertiary'>
              <h2>{t(MENU_SIDEBAR_KEYS.ACCOUNTS)}</h2>
              <span>{t(MENU_KEYS.ACCOUNT_DESC)}</span>
              <img width={45} height={45} src={AccountsIcon} />
            </NavLink>

            <NavLink to={'/portfolio'} className='menu-card-secondary'>
              <h2>{t(MENU_SIDEBAR_KEYS.PORTFOLIO)}</h2>
              <span>{t(MENU_KEYS.PORTFOLIO_DESC)}</span>
              <img width={45} height={45} src={PortfolioIcon} />
            </NavLink>

            <NavLink to={'/requests'} className='menu-card-secondary'>
              <h2>{t(MENU_KEYS.REQUEST)}</h2>
              <span>{t(MENU_KEYS.REQUEST_DESC)}</span>
              <img width={45} height={45} src={Account_RequestIcon} />
            </NavLink>

            <NavLink to='/gimac-pay' className='menu-card-secondary'>
              <h2>{t(MENU_KEYS.GIMAC)}</h2>
              <span>Wallet to wallet, Merchant purchase, Cardless cash etc.</span>
              <img width={45} height={45} src={GimacIcon} />
            </NavLink>
          </div>
          <div>
            <NavLink to={'/beneficiary-transfers'} className='menu-card-secondary'>
              <h2>{t(MENU_SIDEBAR_KEYS.TRANSFERS)}</h2>
              <span>{t(MENU_KEYS.TRANSFER_DESC)}</span>
              <img width={45} height={45} src={TransfersIcon} />
            </NavLink>

            <NavLink to='/payments' className='menu-card-tertiary'>
              <h2>{t(MENU_SIDEBAR_KEYS.PAYMENTS)}</h2>
              <span>{t(MENU_KEYS.PAYMENT_DESC)}</span>
              <img width={45} height={45} src={PaymentsIcon} />
            </NavLink>

            <NavLink to={'/exchange-rate'} className='menu-card-secondary'>
              <h2>{t(MENU_SIDEBAR_KEYS.EXCHANGE_RATE)}</h2>
              <span>{t(MENU_KEYS.DESC_EXCHANGE_RATE)}</span>
              <img width={45} height={45} src={ExchangeRatesIcon} />
            </NavLink>
          </div>
          <div>
            <NavLink to={'/deposits'} className='menu-card-secondary'>
              <h2>{t(MENU_SIDEBAR_KEYS.DEPOSITS)}</h2>
              <span>{t(MENU_KEYS.DEPOSIT_DESC)}</span>
              <img width={45} height={45} src={DepositIcon} />
            </NavLink>

            <NavLink to={'/loans'} className='menu-card-tertiary'>
              <h2>{t(MENU_SIDEBAR_KEYS.LOANS)}</h2>
              <span>{t(ART_WORK_KEYS.LOAN_DESC)}</span>
              <img width={45} height={45} src={LoanIcon} />
            </NavLink>

            <NavLink to={'/additional-links'} className='menu-card-secondary'>
              <h2>{t(MENU_KEYS.OTHER_SERVICES)}</h2>
              <span>{t(MENU_KEYS.OTHER_SERVICE_DESC)}</span>
              <img width={45} height={45} src={Other_SupportCenterIcon} />
            </NavLink>
          </div>
        </div>

        {/* <div className='d-flex dashboard-section'>
             {Object.keys(menuConfig).length > 0 &&
            MENU_OPTIONS.map((option, index) => (
              <>
                {menuConfig[option.key] && Object.keys(menuConfig)[index] === 'ACCOUNTS' ? (
                  <div className='clo-4'>
                    <NavLink to={option.link} className='menu-card-account'>
                      <h2>{t(option.title)}</h2>
                      <h6>{t(option.desc)}</h6>
                      <img width={45} height={45} src={option.icon} />
                    </NavLink>
                  </div>
                ) : Object.keys(menuConfig)[index] === 'LOAN' ||
                  Object.keys(menuConfig)[index] === 'DEPOSITS' ? (
                  <div className='clo-4'>
                    <NavLink to={option.link} className='menu-card-tertiary'>
                      <h2>{t(option.title)}</h2>
                      <h6>{t(option.desc)}</h6>
                      <img width={45} height={45} src={option.icon} />
                    </NavLink>
                  </div>
                ) : (
                  <div className='clo-4'>
                    <NavLink to={option.link} className='menu-card-secondary'>
                      <h2>{t(option.title)}</h2>
                      <h6>{t(option.desc)}</h6>
                      <img width={45} height={45} src={option.icon} />
                    </NavLink>
                  </div>
                )}
              </>
            ))} 
        </div> */}
      </div>
    </Layout>
  )
}
